import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from '../services/api.service';
import { UtilitiesService } from '../services/utilities.service';
import Swal from 'sweetalert2'

@Component({
    selector: 'app-salary',
    templateUrl: './salary.component.html',
    styleUrls: ['./salary.component.css'],
    standalone: false
})
export class SalaryComponent implements OnInit {

  page = 1;
  pageSize = 10;

  list_length = 0;
  total_main_salary: any = 0;
  total_contract_salary: any = 0;

  items_filter: any[] = []
  items: any[] = [];
  employees: any[] = [];
  token: any;

  item = {
    employee_id: 0,
    reward: 0,
    hold: 0,
    work_days: 30,
    paid_salary: 0,
    deduction: 0,
    deduction_reason: null,
    notes: null,
    attachments: null,
    hourly_overtime_price: 0,
    contract_salary: 0,
    hourly_overtime: 0,
    advance_salary: 0
  }

  new_item = {
    employee_id: null,
    reward: 0,
    hold: 0,
    work_days: 30,
    paid_salary: 0,
    deduction: 0,
    deduction_reason: null,
    notes: null,
    attachments: null,
    hourly_overtime_price: 0,
    contract_salary: 0,
    hourly_overtime: 0,
    advance_salary: 0
  }
  files: any;

  new_item_id: number = 0;
  filter_date: any;

  Swal = 'sweetalert2'

  constructor(public utility: UtilitiesService, private modalService: NgbModal, private api: ApiService, public datepipe: DatePipe) {
    this.utility.show = true;
    this.token = localStorage.getItem('access_token');
  }

  ngOnInit(): void {
    this.getItems();
  }

  open(content: any) {
    this.modalService.open(content);
  }

  edit(content: any, salary: any) {
    this.new_item_id = salary.id;
    this.new_item = salary;

    this.new_item.advance_salary = salary.advance;
    this.new_item.hourly_overtime_price = salary.contract_overtime_price;

    this.modalService.open(content);
  }

  getItems() {
    this.utility.loading = true;
    const sub = this.api.get('salarys/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.items = objects;
        this.items_filter = this.items;
        this.list_length = this.items.length;

        this.items.forEach((item) => {
          this.total_main_salary += +item.salary.paid_salary;
        })
      },
      async error => { }
    );
    sub.add(() => { this.getEmployees(); });
  }

  getEmployees() {
    const sub = this.api.get('employees/', this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        this.employees = objects;
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; this.setEmployeeName(); });
  }

  setEmployeeName() {
    this.items.forEach((item) => {
      item.employee = this.employees.find(i => i.id === item.employee_id)?.name;
    })
  }

  async OnSubmit() {
    this.item.paid_salary = (this.item.work_days * (+this.item.contract_salary / 30) + (+this.item.hourly_overtime * +this.item.hourly_overtime_price)) + (this.item.reward) - (this.item.hold + this.item.deduction + this.item.advance_salary);

    const body = {
      employee_id: this.item.employee_id,
      reward: this.item.reward,
      hold: this.item.hold,
      work_days: this.item.work_days,
      paid_salary: this.item.paid_salary,
      deduction: this.item.deduction,
      advance: this.item.advance_salary,
      deduction_reason: this.item.deduction_reason,
      notes: this.item.notes,
      hourly_overtime: this.item.hourly_overtime,
      contract_salary: this.item.contract_salary,
      contract_overtime_price: this.item.hourly_overtime_price
    }

    this.api.post("salarys/", body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Salary Created Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  async onDelete(id: any) {
    if (confirm("Delete this Salary?")) {
      this.api.delete('salarys/' + id, this.token).subscribe(
        async data => {
          this.getItems();
          Swal.fire({
            title: 'Success!',
            text: 'Salary Deleted Successfuly!',
            icon: 'success',
            confirmButtonText: 'Cool'
          })
        },
        async error => {
          Swal.fire({
            title: 'Error!',
            text: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Ok'
          });
        }
      );
    }
  }

  async OnUpdate(id: any) {
    this.new_item.paid_salary = ((+this.new_item.work_days * (+this.new_item.contract_salary / 30)) + (+this.new_item.hourly_overtime * +this.new_item.hourly_overtime_price)) + (+this.new_item.reward) - (+this.new_item.hold + +this.new_item.deduction + +this.new_item.advance_salary);

    const body = {
      employee_id: this.new_item.employee_id,
      reward: this.new_item.reward,
      hold: this.new_item.hold,
      work_days: this.new_item.work_days,
      paid_salary: this.new_item.paid_salary,
      deduction: this.new_item.deduction,
      advance: this.new_item.advance_salary,
      deduction_reason: this.new_item.deduction_reason,
      notes: this.new_item.notes,
      hourly_overtime: this.new_item.hourly_overtime,
      contract_salary: this.new_item.contract_salary,
      contract_overtime_price: this.new_item.hourly_overtime_price
    }

    this.api.update("salarys/" + id, body, this.token).subscribe(
      async data => {
        this.getItems();
        Swal.fire({
          title: 'Success!',
          text: 'Salary Updated Successfuly!',
          icon: 'success',
          confirmButtonText: 'Cool'
        })
      },
      async error => {
        Swal.fire({
          title: 'Error!',
          text: 'Something went wrong!',
          icon: 'error',
          confirmButtonText: 'Ok'
        });
      }
    );

    this.modalService.dismissAll();
  }

  fileChange(event: any) {
    let fileList: FileList = event.target.files;
    this.files = fileList;
  }

  isAdmin() {
    let role = localStorage.getItem('role');

    if (role === 'admin')
      return true;
    return false;
  }

  onEmployeeSelected() {
    this.item.advance_salary = 0;
    this.item.contract_salary = 0;
    this.item.hourly_overtime_price = 0;

    let employee_id = this.item.employee_id;
    let date = new Date();

    let item = this.items.find(i => i.salary.employee_id === employee_id && this.datepipe.transform(i.salary.created_at, 'MM yyyy') == this.datepipe.transform(date, 'MM yyyy'));

    if (item) {
      alert('Employee already has salary on this month');

      this.item.employee_id = 0;
      this.modalService.dismissAll();
    }
    else
      {
        this.utility.loading = true;

        let employee = this.employees.find(i => i.id === employee_id);
        this.item.contract_salary = employee?.basic_salary;

        this.getAdvanceSalary(employee_id);
      }
  }

  // this need to be checked ...
  getAdvanceSalary(id?: any) {
    const sub = this.api.get('salarys/advance/employee/' + id, this.token).subscribe(
      async data => {
        let objects: any = {}
        objects = data;

        let advance: any[] = objects;

        advance.forEach((item) => {
          this.item.advance_salary += +item.salary.amount;
        });
      },
      async error => { }
    );
    sub.add(() => { this.utility.loading = false; });
  }

  getEmployeeInfo(id: any) {
    return this.employees.find(i => i.id === id);
  }

  filterDate() {
    this.items = this.items_filter;
    this.filter_date = this.datepipe.transform(this.filter_date, 'MM yyyy');
    this.items = this.items.filter(i => this.datepipe.transform(i.salary.created_at, 'MM yyyy') === this.filter_date);
  }

  clearFilter() {
    this.items = this.items_filter;
  }
}
